module.exports = __webpack_public_path__ + "img/empty.3b029d7e.png";